export default __webpack_public_path__ + "static/media/timer.d537b51e.svg";